export class OwnerViewService {
    #repository;
    constructor(repository) {
        this.#repository = repository;
    }
    async readHome() {
        const summary = await this.#repository.readHomeSummary();
        return summary === undefined ? [] : [summary];
    }
    async listPeers(params) {
        return await this.#repository.listPeers(params);
    }
    async listFeed(params) {
        return await this.#repository.listFeed(params);
    }
    async readOperational() {
        const summary = await this.#repository.readOperationalSummary();
        return summary === undefined ? [] : [summary];
    }
}
//# sourceMappingURL=owner-view-service.js.map